<template>
    <!--添加好友组件 还需要完善-->
    <div class="wepay-wallet">
        <header id="wx-header" class="wx-header">
            <div class="center">
                <div v-on:click="$router.back()" class="iconfont icon-return-arrow">
                    <span>返回</span>
                </div>
            </div>
        </header>
        <div class="body">
            <img src="/images/pay/wepay3.jpg" width="100%" alt="">
        </div>
    </div>
</template>
<script>
    export default {}
</script>
<style lang="less">
.wepay-wallet {
    height: 100%;
    background-color: #fff;
    .body {
        position: relative;
    }
    .wx-header {
        background-color: #fff !important;
        .iconfont {
            color: #000 !important;
        }
    }
}
</style>